import { cloneDeep, isNil } from 'lodash';

import { CommunicationWorkflowTargetOrderBy } from '@pwp-common';

import { defaultTargetOrderBy } from '../default-target-order-by';
import { TargetOrderByEditorOutput } from '../target-order-by-editor-output';

export const dbToTargetOrderByEditorOutput = (
  orderBy: CommunicationWorkflowTargetOrderBy,
): TargetOrderByEditorOutput => {
  if (isNil(orderBy)) {
    return cloneDeep(defaultTargetOrderBy);
  }

  return {
    type: orderBy.getType(),
  };
};
